module.exports = __webpack_public_path__ + "static/media/Scrum.4af3e09f.png";